import useUser from "../../../../core/hooks/use-user";
import { toast } from "../../../../core/helpers/message-helper";
import Datatable from "../../../../core/ui/components/Datatable";
import { API_URL } from "../../../../core/config/env";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import useModal from "../../../../core/hooks/use-modal";
import FormGrupos from "../components/form-grupos-permisos";
import { useState } from "react";
import swal from "sweetalert";
import { sweetAl } from "../../../../core/helpers/message-helper";
import {
    activarGrupo,
    inactivarGrupo,
} from "../../services/permisos-grupos-service";

const GruposPermisos = () => {
    const { getAccessToken, userCan } = useUser();
    const token = getAccessToken();
    const [dtInstance, onDtInstance] = useState({});

    const modalGrupos = useModal({
        title: "Agregar Grupo",
        data: { grupo: {} },
    });

    const getDtInstance = (dt) => onDtInstance(dt);

    const onSave = () => {
        dtInstance.ajax.reload();
    };

    let tableButtons = [];

    if (userCan("gruposPermisosCrear")) {
        tableButtons.push({
            titleAttr: "Agregar Grupo",
            text: '<i class="fas fa-plus"></i>',
            action: function () {
                modalGrupos.open({
                    title: "Agregar Grupo",
                    data: { grupo: {} },
                });
            },
            className: "btn btn-sm btn-secondary",
        });
    }

    if (userCan("gruposPermisosEditar")) {
        tableButtons.push({
            titleAttr: "Editar Grupo",
            text: '<i class="fas fa-pen"></i>',
            action: async (_, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                modalGrupos.open({
                    title: "Editar Grupo",
                    data: { grupo: data },
                });
            },
            className: "btn btn-sm btn-grey",
        });
    }

    if (userCan("gruposPermisosInactivar")) {
        tableButtons.push({
            titleAttr: "Inactivar Grupo",
            text: '<i class="fas fa-trash"></i>',
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea inactivar este grupo?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        eliminar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning("No se ha inactivado el grupo");
                        break;
                    case "eliminar": {
                        const resp = await inactivarGrupo(data.id);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al inactivar el grupo"
                            );
                        }

                        sweetAl.success(
                            "El grupo fue inactivado correctamente"
                        );
                        dt.ajax.reload();
                        break;
                    }
                }
            },
            className: "btn btn-sm btn-danger",
        });
    }

    if (userCan("gruposPermisosActivar")) {
        tableButtons.push({
            titleAttr: "Activar Grupo",
            text: '<i class="fas fa-check"></i>',
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea activar este grupo?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        activar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning("No se ha activado el grupo");
                        break;
                    case "activar": {
                        const resp = await activarGrupo(data);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al activar el grupo"
                            );
                        }

                        sweetAl.success("El grupo fue activado correctamente");
                        dt.ajax.reload();
                        break;
                    }
                }
            },
            className: "btn btn-sm btn-primary",
        });
    }

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "grupos",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tablaGruposPermisos",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/administrar/gruposPermisos`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error(
                    "Ha ocurrido un error al obtener el listado de grupos"
                );
            },
        },
        columns: [{ data: "id" }, { data: "nombre" }, { data: "status" }],
        columnDefs: [
            {
                targets: 2,
                createdCell: function (td, cellData) {
                    td.textContent = cellData == 1 ? "Activo" : "Inactivo";
                    td.classList.add(
                        cellData == 1 ? "text-success" : "text-warning"
                    );
                    td.classList.add("text-bold");
                },
            },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    ADMINISTRAR / Grupos De Permisos
                </div>
            </div>
            <Datatable options={dtOptions} dtInstance={getDtInstance}>
                <table
                    className="w-100 table table-hover"
                    id="tablaGruposPermisos"
                >
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Nombre</th>
                            <th>Estado</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
            <FormGrupos modalState={modalGrupos} onSave={onSave} />
        </ContentWrapper>
    );
};

export default GruposPermisos;
